export default [
  {
    path: "/inventory",
    name: "inventory",
    component: () =>
      import("../components/modules/inventory/InventoryList.vue"),
  },
];
